/*
  EV slider: a dependency-free stand-in for the Slick configurations used on the Everly layout.

  Markup:
    <div class="ev-sl" data-ev-slider='{"show":3,"scroll":2,"infinite":true,"bp":[[1023,2],[767,3]],
         "prev":".x-prev","next":".x-next","dots":".x-dots","nav":".x-thumbs"}'>
      <div class="ev-sl__list"><div class="ev-sl__track">
        <div class="ev-sl__slide">…</div> …
      </div></div>
    </div>
  - "bp": [[maxWidth, show], …] mirrors Slick's `responsive` (applies when window width <= maxWidth).
  - "prev" / "next" / "dots" / "nav" are selectors resolved inside the closest `.ev` section root.
  - "nav": another [data-ev-slider] acting as the thumbnail strip (Slick asNavFor).
  Layout is pure CSS (see ev-style): JS only sets --ev-show and --ev-i on the root.
*/
(function () {
  if (window.EVSlider) return;

  function EVSlider(root) {
    if (root.__ev) return root.__ev;
    var cfg = {};
    try { cfg = JSON.parse(root.getAttribute('data-ev-slider') || '{}'); } catch (e) { }
    var scope = root.closest('.ev') || document;
    var track = root.querySelector('.ev-sl__track');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var n = slides.length;
    var q = function (sel) { return sel ? scope.querySelector(sel) : null; };
    var prev = q(cfg.prev), next = q(cfg.next), dotsEl = q(cfg.dots);
    var self = { root: root, index: 0, onChange: [] };
    root.__ev = self;

    function show() {
      var s = cfg.show || 1;
      (cfg.bp || []).slice().sort(function (a, b) { return b[0] - a[0]; }).forEach(function (b) {
        if (window.innerWidth <= b[0]) s = b[1];
      });
      return Math.max(1, Math.min(s, n || 1));
    }
    function step() { return Math.max(1, Math.min(cfg.scroll || 1, show())); }
    function maxIndex() { return Math.max(0, n - show()); }
    function dotCount() {
      if (n <= show()) return 0;
      return cfg.infinite ? Math.ceil(n / step()) : 1 + Math.ceil((n - show()) / step());
    }

    function render() {
      var s = show();
      root.style.setProperty('--ev-show', s);
      root.style.setProperty('--ev-i', Math.min(self.index, maxIndex()));
      slides.forEach(function (el, i) {
        el.classList.toggle('is-current', i === self.index);
        el.classList.toggle('is-visible', i >= Math.min(self.index, maxIndex()) && i < Math.min(self.index, maxIndex()) + s);
      });
      if (dotsEl) {
        var c = dotCount();
        if (dotsEl.children.length !== c) {
          dotsEl.innerHTML = '';
          for (var d = 0; d < c; d++) {
            var b = document.createElement('button');
            b.type = 'button';
            b.setAttribute('aria-label', 'Go to slide group ' + (d + 1));
            (function (d) { b.addEventListener('click', function () { go(d * step()); }); })(d);
            dotsEl.appendChild(b);
          }
        }
        var active = Math.min(dotsEl.children.length - 1, Math.ceil(Math.min(self.index, maxIndex()) / step()));
        Array.prototype.forEach.call(dotsEl.children, function (b, i) {
          b.classList.toggle('is-on', i === active);
          b.classList.toggle('is-past', i < active);
        });
        dotsEl.style.display = c ? '' : 'none';
      }
      if (!cfg.infinite) {
        if (prev) prev.disabled = self.index <= 0;
        if (next) next.disabled = self.index >= maxIndex();
      }
    }

    function go(i, silent) {
      var max = cfg.nav || cfg.isNav ? n - 1 : maxIndex();
      if (cfg.infinite) {
        if (i > maxIndex() && self.index >= maxIndex()) i = 0;
        else if (i < 0 && self.index <= 0) i = maxIndex();
      }
      self.index = Math.max(0, Math.min(i, max));
      render();
      if (!silent) self.onChange.forEach(function (fn) { fn(self.index); });
    }
    self.go = go;
    self.next = function () { go(self.index + step()); };
    self.prev = function () { go(self.index - step()); };

    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); self.prev(); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); self.next(); });

    var x0 = null, y0 = null;
    root.addEventListener('pointerdown', function (e) { x0 = e.clientX; y0 = e.clientY; });
    root.addEventListener('pointerup', function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0, dy = e.clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { if (dx < 0) self.next(); else self.prev(); }
    });
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { if (dx < 0) self.next(); else self.prev(); }
    }, { passive: true });

    if (cfg.nav) {
      var navEl = q(cfg.nav);
      if (navEl) {
        var nav = EVSlider(navEl);
        var syncNav = function (i) {
          nav.root.querySelectorAll('.ev-sl__slide').forEach(function (s, k) { s.classList.toggle('is-selected', k === i); });
          var s = parseInt(getComputedStyle(nav.root).getPropertyValue('--ev-show'), 10) || 1;
          if (i < nav.index || i >= nav.index + s) nav.go(Math.min(i, Math.max(0, nav.root.querySelectorAll('.ev-sl__slide').length - s)), true);
        };
        self.onChange.push(syncNav);
        nav.root.querySelectorAll('.ev-sl__slide').forEach(function (s, k) {
          s.addEventListener('click', function () { go(k); });
        });
        syncNav(0);
      }
    }

    window.addEventListener('resize', render);
    render();
    return self;
  }

  function initAll(ctx) {
    (ctx || document).querySelectorAll('[data-ev-slider]').forEach(EVSlider);
  }
  window.EVSlider = EVSlider;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
